import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["source", "feedback"]
  static values = { copied: String, hideDelay: Number }

  copy(event) {
    event.preventDefault()
    const text = this.sourceTarget.textContent.trim()

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => this.confirm())
      return
    }

    const field = document.createElement("textarea")
    field.value = text
    field.setAttribute("readonly", "readonly")
    field.style.position = "absolute"
    field.style.left = "-9999px"
    document.body.appendChild(field)
    field.select()
    document.execCommand("copy")
    field.remove()
    this.confirm()
  }

  confirm() {
    if (!this.hasFeedbackTarget) return

    this.feedbackTarget.hidden = false
    this.feedbackTarget.textContent = this.copiedValue

    if (!this.hasHideDelayValue) return

    clearTimeout(this.hideTimer)
    this.hideTimer = setTimeout(() => {
      this.feedbackTarget.hidden = true
    }, this.hideDelayValue)
  }

  disconnect() {
    clearTimeout(this.hideTimer)
  }
}
